import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import 'simplebar-core/dist/simplebar.css';
import navigation from '../_nav';
import 'font-awesome/css/font-awesome.min.css';
import '../scss/Appsidebar.scss';

const AppSidebar = (isSidebarFolded) => {
  const dispatch = useDispatch();
  const unfoldable = useSelector((state) => state.sidebarUnfoldable);
  const sidebarShow = useSelector((state) => state.sidebarShow);

  const [openDropdown, setOpenDropdown] = useState(null);
  const [isExpanded, setIsExpanded] = useState(true);
  const [isSuperuser, setIsSuperuser] = useState(true);

  const handleDropdownToggle = (index) => {
    setOpenDropdown(openDropdown === index ? null : index);
  };

  const toggleSidebar = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    if (!isExpanded) {
      setOpenDropdown(null);
    }
  }, [isExpanded]);

  useEffect(() => {
    if (isSidebarFolded) {
      setOpenDropdown(null);
    }

    const superuserStatus = sessionStorage.getItem('superuser') === 'true';
    setIsSuperuser(superuserStatus);
  }, [isSidebarFolded]);

  const filteredNavigation = navigation.map(item => {
    if (item.name === 'Meter Config' && !isSuperuser) {
      return false;
    }
    if (item.name === 'User List' && !isSuperuser) {
      return false;
    }
    if (item.name === 'Rule Engine' && !isSuperuser) {
      return false;
    }
    if (item.name === 'Settings' && !isSuperuser) {
      return false;
    }
    if (item.name === 'Flow Meter' && !isSuperuser) {
      return false;
    }
    if (item.name === 'Water Level Meter' && !isSuperuser) {
      return false;
    }
    if (item.name === 'Schedules' && !isSuperuser) {
      return false;
    }
    if (item.name === 'User Group' && !isSuperuser) {
      return false;
    }
    if (item.name === 'EnPI') {
      return {
        ...item,
        submenu: item.submenu.filter(sub => !(sub.name === 'Equipment List' && !isSuperuser))
      };
    }
    return item;
  }).filter(Boolean);

  return (
    <div className="app-container">
      <div
        className={`app-sidebar ${sidebarShow ? 'visible' : 'hidden'} ${unfoldable ? 'unfoldable' : ''}`}
        style={{
          position: 'fixed',
          height: '100vh',
          backgroundColor: '#047BC4',
          color: 'white',
          width: isExpanded ? (unfoldable ? '200px' : '60px') : '200px',
          transition: 'width 0.3s',
          display: 'flex',
          flexDirection: 'column',
        }}
        onMouseEnter={() => isExpanded && dispatch({ type: 'SET_SIDEBAR_UNFOLDABLE', payload: true })}
        onMouseLeave={() => isExpanded && dispatch({ type: 'SET_SIDEBAR_UNFOLDABLE', payload: false })}
      >
        <div className="sidebar-brand">
          <img
            src="/brad.png"
            alt="Logo"
            className="sidebar-logo"
            style={{
              width: unfoldable ? '120px' : '53.5px',
              height: 'auto',
              transition: 'width 0.3s ease-in-out',
            }}
          />
        </div>

        <nav className="sidebar-nav" style={{ 
          flex: 1,
          overflowY: 'auto',
          overflowX: 'hidden',
          width: '200px'
        }}>
          <ul style={{ listStyle: 'none', padding: '0', margin: '0' }}>
            {Array.isArray(filteredNavigation) ? (
              filteredNavigation.map((item, index) => (
                <li
                  key={index}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                    marginBottom: '5px',
                  }}
                >
                  {item.submenu ? (
                    <>
                      <div
                        onClick={() => handleDropdownToggle(index)}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          cursor: 'pointer',
                          padding: '12px 10px',
                          borderRadius: '5px',
                        }}
                      >
                        <span style={{ marginRight: '10px', fontSize: '18px' }}>{item.icon}</span>
                        {unfoldable && (
                          <span style={{ fontSize: '16px', fontWeight: 'bold', flex: 1 }}>
                            {item.name}
                          </span>
                        )}
                      </div>

                      {openDropdown === index && (
                        <ul
                          style={{
                            marginTop: '5px',
                            paddingLeft: '20px',
                          }}
                        >
                          {item.submenu.map((subItem, subIndex) => (
                            <li key={subIndex} style={{ margin: '5px 0' }}>
                              <Link
                                to={subItem.path}
                                style={{
                                  fontSize: '14px',
                                  color: 'white',
                                  textDecoration: 'none',
                                  display: 'block',
                                  padding: '5px 10px',
                                  borderRadius: '5px',
                                  transition: 'background 0.3s',
                                }}
                                onMouseOver={(e) => (e.target.style.backgroundColor = 'transparent')}
                                onMouseOut={(e) => (e.target.style.backgroundColor = 'transparent')}
                              >
                                {subItem.name}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </>
                  ) : (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '12px 10px',
                        borderRadius: '5px',
                      }}
                    >
                      <span style={{ marginRight: unfoldable ? '10px' : '0', fontSize: '18px' }}>
                        {item.icon}
                      </span>
                      {unfoldable && (
                        <Link
                          to={item.path}
                          style={{
                            color: 'white',
                            textDecoration: 'none',
                            fontSize: '16px',
                            fontWeight: 'bold',
                          }}
                        >
                          {item.name}
                        </Link>
                      )}
                    </div>
                  )}
                </li>
              ))
            ) : (
              <li style={{ padding: '10px', color: 'red' }}>Error: Navigation data is not an array</li>
            )}
          </ul>
        </nav>
        <div
          className="sidebar-toggle"
          onClick={toggleSidebar}
        >
          {isExpanded ? (
            <i className="fas fa-chevron-left" style={{ fontSize: '16px' }} />
          ) : (
            <i className="fas fa-chevron-right" style={{ fontSize: '16px' }} />
          )}
        </div>
      </div>

      <div
        className="content-wrapper"
        style={{
          marginLeft: isExpanded ? (unfoldable ? '200px' : '55px') : '200px',
          transition: 'margin-left 0.3s ease',
        }}
      >

      </div>
    </div>
  );
};

export default React.memo(AppSidebar);